<template>
  <div class='jbxx'>
    <div class='jbxx-item'>
      <div class='title'>企业简介</div>
      <div class='base-list'>
        <el-row class='row'>
          <el-col v-for='(item, index) in baseInfo' :key='index' type='flex' :span='8'>
            <el-row>
              <el-col class='border' :span='8'>{{item.name}}</el-col>
              <el-col class='border' :span='16'>
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :content="String(item.value)"
                  :open-delay="300"
                  >
                  <div class="baseInfo-value">{{item.value}}</div>
                </el-tooltip>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class='jbxx-item'>
      <div class='title'>工商登记股东信息</div>
      <div class='ux-tabs tabs' style='margin:0 40px;
        width:calc(100% - 80px);min-height:100px'>
        <div class='ux-filter-records filter-records'>
          <div class='content-list' style='height:auto'>
            <el-table
              empty-text="暂无数据"
              class='table ux-dark-el-table'
              :data='tableData1'
              element-loading-spinner='el-icon-loading'>
                <el-table-column v-for='(props, i) in tableHeader1' :label='props.label' align='center' :key='i' show-overflow-tooltip>
                  <template slot-scope='scope'>
                    <div v-if='props.type'>
                      {{scope.$index + 1}}
                    </div>
                    <div v-else class='text'>{{ scope.row[props.prop] }}</div>
                  </template>
                </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class='jbxx-item'>
      <div class='title'>对外投资核查</div>
      <div class='ux-tabs tabs' style='margin:0 40px;
        width:calc(100% - 80px);min-height:100px'>
        <div class='ux-filter-records filter-records'>
          <div class='content-list' style='height:auto'>
            <el-table
              empty-text="暂无数据"
              class='table ux-dark-el-table'
              :data='tableData2'
              element-loading-spinner='el-icon-loading'>
                <el-table-column v-for='(props, i) in tableHeader2' :label='props.label' align='center' :key='i' show-overflow-tooltip>
                  <template slot-scope='scope'>
                    <div v-if='props.prop === "index"'>
                      {{scope.$index + 1}}
                    </div>
                    <div v-else class='text'>
                      <div v-if="props.prop === 'Oper'">
                      {{   scope.row[props.prop].Name }}
                      </div>
                      <div v-else>
                        {{ scope.row[props.prop] }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class='jbxx-item'>
      <div class='title'>所有受益人</div>
      <div class='ux-tabs tabs' style='margin:0 40px;
        width:calc(100% - 80px);min-height:100px'>
        <div class='ux-filter-records filter-records'>
          <div class='content-list' style='height:auto'>
            <el-table
              empty-text="暂无数据"
              class='table ux-dark-el-table'
              :data='tableData3'
              element-loading-spinner='el-icon-loading'>
                <el-table-column v-for='(props, i) in tableHeader3' :label='props.label' align='center' :key='i' show-overflow-tooltip>
                  <template slot-scope='scope'>
                    <div v-if='props.prop === "index"'>
                      {{scope.$index + 1}}
                    </div>
                    <div v-else class='text'>{{ scope.row[props.prop] }}</div>
                  </template>
                </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class='jbxx-item'>
      <div class='title'>法律诉讼</div>
     <div class="title2">
      被执行人核查：
     </div>
      <div class='ux-tabs tabs' style='margin:0 40px;
        width:calc(100% - 80px);min-height:100px'>
        <div class='ux-filter-records filter-records'>
          <div class='content-list' style='height:auto'>
            <el-table
              empty-text="暂无数据"
              class='table ux-dark-el-table'
              :data='tableData4'
              element-loading-spinner='el-icon-loading'>
                <el-table-column v-for='(props, i) in tableHeader4' :label='props.label' align='center' :key='i' show-overflow-tooltip>
                  <template slot-scope='scope'>
                    <div v-if='props.prop === "index"'>
                      {{scope.$index + 1}}
                    </div>
                    <div v-else class='text'>{{ scope.row[props.prop] }}</div>
                  </template>
                </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class='jbxx-item'>
     <div class="title2 mTop">
      失信核查:
     </div>
      <div class='ux-tabs tabs' style='margin:0 40px;
        width:calc(100% - 80px);min-height:100px'>
        <div class='ux-filter-records filter-records'>
          <div class='content-list' style='height:auto'>
            <el-table
              empty-text="暂无数据"
              class='table ux-dark-el-table'
              :data='tableData5'
              element-loading-spinner='el-icon-loading'>
                <el-table-column v-for='(props, i) in tableHeader5' :label='props.label' align='center' :key='i' show-overflow-tooltip>
                  <template slot-scope='scope'>
                    <div v-if='props.prop === "index"'>
                      {{scope.$index + 1}}
                    </div>
                    <div v-else class='text'>{{ scope.row[props.prop] }}</div>
                  </template>
                </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class='jbxx-item'>
     <div class="title2 mTop">
      限高消费:
     </div>
      <div class='ux-tabs tabs' style='margin:0 40px;
        width:calc(100% - 80px);min-height:100px'>
        <div class='ux-filter-records filter-records'>
          <div class='content-list' style='height:auto'>
            <el-table
              empty-text="暂无数据"
              class='table ux-dark-el-table'
              :data='tableData6'
              element-loading-spinner='el-icon-loading'>
                <el-table-column v-for='(props, i) in tableHeader6' :label='props.label' align='center' :key='i' show-overflow-tooltip>
                  <template slot-scope='scope'>
                    <div v-if='props.prop === "index"'>
                      {{scope.$index + 1}}
                    </div>
                    <div v-else class='text'>{{ scope.row[props.prop] }}</div>
                  </template>
                </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class='jbxx-item'>
     <div class="title2 mTop">
      行政处罚:
     </div>
      <div class='ux-tabs tabs' style='margin:0 40px;
        width:calc(100% - 80px);min-height:100px'>
        <div class='ux-filter-records filter-records'>
          <div class='content-list' style='height:auto'>
            <el-table
              empty-text="暂无数据"
              class='table ux-dark-el-table'
              :data='tableData7'
              element-loading-spinner='el-icon-loading'>
                <el-table-column v-for='(props, i) in tableHeader7' :label='props.label' align='center' :key='i' show-overflow-tooltip>
                  <template slot-scope='scope'>
                    <div v-if='props.prop === "index"'>
                      {{scope.$index + 1}}
                    </div>
                    <div v-else class='text'>{{ scope.row[props.prop] }}</div>
                  </template>
                </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import common from '@/utils/common'
// import languageObj from '@/utils/lan.json'
import apiPath from '@config/api.json'
import { Loading } from 'element-ui'
// let img = require('@/assets/images/home/fc.png')
const {mapState, mapMutations} = require('vuex')
export default {
  components: {},
  props: ['info'],
  data () {
    return {
      baseInfo: [
        {
          name: '企业名称',
          prop: 'a',
          value: ''
        }, {
          name: '统一信用代码',
          prop: 'a',
          value: ''
        }, {
          name: '企业所在地',
          prop: 'a',
          value: ''
        }, {
          name: '法定代表人',
          prop: 'a',
          value: ''
        }, {
          name: '电话号码',
          prop: 'a',
          value: ''
        }, {
          name: '手机号码',
          prop: 'a',
          value: ''
        }, {
          name: '注册资本',
          prop: 'a',
          value: ''
        }, {
          name: '注册时间',
          prop: 'a',
          value: ''
        }, {
          name: '营业执照期限',
          prop: 'a',
          value: ''
        }, {
          name: '主营产品',
          prop: 'a',
          value: ''
        }, {
          name: '主要销售市场',
          prop: 'a',
          value: ''
        },
        {
          name: '主要业务平台及销售额',
          prop: 'a',
          value: ''
        }, {
          name: '海关编码',
          prop: 'a',
          value: ''
        },
        {}, {}
      ],
      showImgModel: '',
      tableHeader1: [
        {
          prop: 'StockName',
          label: '股东名称'
        },
        {
          prop: 'StockPercent',
          label: '持股比例'
        },
        {
          prop: 'ShoudDate',
          label: '认缴出资日期'
        },
        {
          prop: 'StakeDate',
          label: '首次持股日期'
        }
      ],
      tableData1: [],
      tableHeader2: [
        {
          prop: 'index',
          label: '序号'
        },
        {
          prop: 'Name',
          label: '被投资企业名称'
        },
        {
          prop: 'Oper',
          label: '被投资企业法定代表人'
        },
        {
          prop: 'Status',
          label: '状态'
        },
        {
          prop: 'StartDate',
          label: '成立日期'
        },
        {
          prop: 'InvestDate',
          label: '投资日期'
        },
        {
          prop: 'FundedRatio',
          label: '持股比例'
        },
        {
          prop: 'ShouldCapi',
          label: '认缴出资额'
        }
      ],
      tableData2: [],
      tableData3: [],
      tableHeader3: [
        {
          prop: 'index',
          label: '序号'
        },
        {
          prop: 'name',
          label: '受益人名称'
        },
        {
          prop: 'totalStockPercent',
          label: '最终受益人股份'
        },
        {
          prop: 'benifitType',
          label: '收益类型'
        },
        {
          prop: 'benifitType',
          label: '任职类型'
        },
        {
          prop: 'remark',
          label: '判定理由'
        }
      ],
      tableData4: [],
      tableHeader4: [
        {
          prop: 'index',
          label: '序号'
        },
        {
          prop: 'Anno',
          label: '案号'
        },
        {
          prop: 'ExecuteGov',
          label: '执行法院'
        },
        {
          prop: 'Biaodi',
          label: '执行标的(元)'
        },
        {
          prop: 'Liandate',
          label: '立案日期'
        },
        {
          prop: 'SuspectedApplicant',
          label: '疑似申请执行人'
        }
      ],
      tableData5: [],
      tableHeader5: [
        {
          prop: 'index',
          label: '序号'
        },
        {
          prop: 'Anno',
          label: '案号'
        },
        {
          prop: 'Executegov',
          label: '执行法院'
        },
        {
          prop: 'Executegov',
          label: '执行依据文号'
        },
        {
          prop: 'Amount',
          label: '涉嫌金额'
        },
        {
          prop: 'ActionRemark',
          label: '失信行为'
        },
        {
          prop: 'Liandate',
          label: '立案日期'
        },
        {
          prop: 'Publicdate',
          label: '发布日期'
        }
      ],
      tableData6: [],
      tableHeader6: [
        {
          prop: 'index',
          label: '序号'
        },
        {
          prop: 'CaseNo',
          label: '案号'
        },
        {
          prop: 'CompanyName',
          label: '限制消令对象'
        },
        {
          prop: 'PersonName',
          label: '关联对象'
        },
        {
          prop: 'Applicant',
          label: '申请人'
        },
        {
          prop: 'JudgeDate',
          label: '立案日期'
        },
        {
          prop: 'PublishDate',
          label: '发布日期'
        }
      ],
      tableData7: [],
      tableHeader7: [
        {
          prop: 'index',
          label: '序号'
        },
        {
          prop: 'DocNo',
          label: '决定文书号'
        },
        {
          prop: 'PunishReason',
          label: '违法事实'
        },
        {
          prop: 'PunishResult',
          label: '处罚结果'
        },
        {
          prop: 'PunishOffice',
          label: '处罚单位'
        },
        {
          prop: 'PunishDate',
          label: '处罚日期'
        }
      ],
      loadTips: ''
    }
  },

  computed: {
    ...mapState({
      searchDate: (state) => {
        return state.home.searchDate
      }
    })
  },

  watch: {
    searchDate: function (n) {
      // this.init()
    }
  },

  created () {
    // this.setLanguageMsg(this.lan)
  },

  mounted () {
    this.init()
  },

  methods: {
    ...mapMutations(),
    init () {
      this.checkKycOne()
      this.checkKycTwo()
      this.loadTips = Loading.service()
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.jbxx.getEnterpriseInformation}/${this.info.customerNo}`
        // url: `${apiPath.bigData.search.jbxx.getEnterpriseInformation}/AAAC`
      }).then(res => {
        if (res.data) {
          let customerSettleParkInfo = res.data
          this.baseInfo = [
            {
              name: '企业名称',
              prop: 'a',
              value: customerSettleParkInfo.customerName
            }, {
              name: '统一信用代码',
              prop: 'a',
              value: customerSettleParkInfo.icUnifiedSocialCreditCode
            }, {
              name: '企业所在地',
              prop: 'a',
              value: customerSettleParkInfo.address
            }, {
              name: '法定代表人',
              prop: 'a',
              value: customerSettleParkInfo.legalName
            }, {
              name: '电话号码',
              prop: 'a',
              value: customerSettleParkInfo.legalTel
            }, {
              name: '手机号码',
              prop: 'a',
              value: customerSettleParkInfo.legalPhone
            }, {
              name: '注册资本',
              prop: 'a',
              value: customerSettleParkInfo.icRegisteredCapital
            }, {
              name: '注册时间',
              prop: 'a',
              value: customerSettleParkInfo.establishmentDate
            }, {
              name: '营业执照期限',
              prop: 'a',
              value: customerSettleParkInfo.icBusinessTerm
            }, {
              name: '主营产品',
              prop: 'a',
              value: customerSettleParkInfo.icBusinessScope
            }, {
              name: '主要销售市场',
              prop: 'a',
              value: customerSettleParkInfo.mainSaleMarket
            },
            {
              name: '主要业务平台及销售额',
              prop: 'a',
              value: customerSettleParkInfo.mainBusSales
            }, {
              name: '海关编码',
              prop: 'a',
              value: customerSettleParkInfo.customsMode
            },
            {}, {}
          ]
          this.checkKycMap(res.data.kycMap)
        } else {
          this.loadTips.close()
        }
      })
    },
    checkKycOne () {
      this.loadTips = Loading.service()
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.jbxx.partOne}`,
        data: {
          customerNo: this.info.customerNo,
          companyName: this.info.customerName
        }
      }).then(res => {
        if (res.data) {
          if (res.data && res.data.length) {
            res.data.forEach(item => {
              this.checkKycMap(item.data)
            })
          }
        } else {
          this.loadTips.close()
        }
      })
    },
    checkKycTwo () {
      this.loadTips = Loading.service()
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.jbxx.partTwo}`,
        data: {
          customerNo: this.info.customerNo,
          companyName: this.info.customerName
        }
      }).then(res => {
        if (res.data) {
          res.data.forEach(item => {
            this.checkKycMap(item.data)
          })
        } else {
          this.loadTips.close()
        }
      })
    },
    // 数据处理
    checkKycMap (obj) {
      let setKycList = []
      for (let key in obj) {
        let o = {
          key: key,
          name: '',
          head: []
        }
        if (obj[key]) {
          let getItem = JSON.parse(obj[key])
          o.name = getItem['name']
          let geHead = getItem['head']
          let seHead = geHead || []
          try {
            seHead = JSON.parse(geHead)
          } catch (e) {}
          o['head'] = seHead
          let getData = getItem['data']
          let setData = getData || {}
          try {
            setData = JSON.parse(getData)
          } catch (e) {}
          o['data'] = setData
        }
        setKycList.push(o)
      }
      for (let index = 0; index < setKycList.length; index++) {
        const element = setKycList[index].key
        switch (element) {
          case '731':
            this.tableData1 = setKycList[index].data || []
            break
          case '740':
            this.tableData5 = setKycList[index].data || []
            break
          case '741':
            this.tableData4 = setKycList[index].data || []
            break
          case '742':
            this.tableData6 = setKycList[index].data || []
            break
          case '865':
            this.tableData7 = setKycList[index].data || []
            break
          case '884':
            this.tableData2 = setKycList[index].data || []
            break
          case '1003':
            this.tableData3 = setKycList[index].data || []
            break
        }
      }
      this.loadTips.close()
    }
  }
}
</script>

<style lang='scss' scoped>
.baseInfo-value{
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
}
  .jbxx{
    .jbxx-item{
      .title{
        color:#fff;
        font-size:18px;
        margin-top:18px;
        margin-left:40px;
      }
      .title2 {
        margin-left:40px;
        font-size: 14px;
        color: #777984;
      }
      .mTop{
        margin-top:18px;
      }
      .base-list{
        margin:0 40px;
        margin-top: 16px;
        border:1px solid #22bdfe;
        .row{
          font-size:16px;
          line-height: 40px;
        }
        .border{
          border:1px solid #22bdfe;
          text-align: center;
          height: 36px;
          line-height: 36px;
          overflow-y: hidden;
          // width: 100%;
          overflow-x: auto;
        }
      }
      .img-list{
        display: flex;
        margin:0 40px;
        margin-top: 16px;
        flex-wrap: wrap;
        width: calc(100% - 80px);
        .photos_image{
          width: 100px;
          height: 100px;
          margin-right:16px;
          margin-bottom:8px;
        }
      }
    }
  }
</style>
<style>
  .jbxx {

  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/jbxx.vue